"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responsiblePartyOptions = exports.modeOptions = exports.invoiceTypeOptions = exports.chargeCategoryOptions = void 0;
var modeOptions = [
    { key: "cost", label: "Cost (R)" },
    { key: "quantity", label: "Quantity" },
];
exports.modeOptions = modeOptions;
var responsiblePartyOptions = [
    { key: "all", label: "All Parties" },
    { key: "Tenant", label: "Tenant" },
    { key: "Landlord", label: "Landlord" },
];
exports.responsiblePartyOptions = responsiblePartyOptions;
// Consumption-category filter: higher-level groupings requested by the client.
// Mapping to backend `category` / chargeType is done client-side in analysis.tsx.
//   - Consumption  → energy + demand (usage-based charges)
//   - Day-Based    → fixed day-rate charges (Service Charge, Admin Charge — R/day)
//   - Capacity     → fixed kVA-based charges (Network Capacity, Generation Capacity — R/kVA)
//   - Fixed        → all other fixed per-kWh levies (Affordability, Legacy, Ancillary, Electrification, Network Demand)
var chargeCategoryOptions = [
    { key: "all", label: "All Categories" },
    { key: "consumption", label: "Consumption" },
    { key: "day-based", label: "Day-Based" },
    { key: "capacity", label: "Capacity" },
    { key: "fixed", label: "Fixed" },
];
exports.chargeCategoryOptions = chargeCategoryOptions;
// Invoice type filter — static options for now; later this will be derived per-building configuration.
var invoiceTypeOptions = [
    { key: "all", label: "All Invoice Types" },
    { key: "rental", label: "Rental" },
    { key: "services", label: "Services" },
    { key: "other", label: "Other" },
];
exports.invoiceTypeOptions = invoiceTypeOptions;
